import { useMemo } from 'react';
import { useFieldContext } from '../../../architecture/hooks/use-field-context/use-field.context';
import type { LabelElementProps, LabelProps } from './label.props';
import { useRenderedMarkup } from '../../../architecture/hooks/use-rendered-markup/use-rendered-markup.hook';

const Label = ({ htmlFor, className, children }: LabelProps) => {
  const fieldContext = useFieldContext();
  const labelId = useMemo(() => fieldContext?.sharedId || htmlFor, [fieldContext?.sharedId, htmlFor]);

  return useRenderedMarkup<undefined, LabelElementProps>({
    wrapperElement: 'label',
    elementProps: { htmlFor: labelId },
    className,
    children,
  });
};

export { Label };
